function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ManagerTemplate = require('./manager.template');
var ManagerHeaderTemplate = require('./manager-header.template');
var ManagerScrollFooterTemplate = require('./manager-scroll-footer.template');
var ManagerLoadMore = require('./manager-load-more');
var TweetTemplate = require('./tweet.template');
var SaitoImageOverlay = require('../../../lib/saito/ui/saito-image-overlay/saito-image-overlay');
var SCROLL_THRESHOLD_PX = 240;
var Manager = /*#__PURE__*/function () {
  function Manager(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Manager);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.mode = 'timeline';
    this.active_signature = '';
    this.active_thread_id = '';
    this.active_profile_key = '';
    this.timeline_rendered = false;
    this.notifications_rendered = false;
    this.scroll_positions = {
      timeline: 0,
      notifications: 0,
      thread: 0,
      posts: 0,
      replies: 0,
      likes: 0
    };
    this.pagination = this.createPaginationState();
    this.pending_newer_tweets = [];
    this._timeline_bootstrapping = false;
    this._notifications_bootstrapping = false;
    this.pending_route_signature = '';
    this.permalink_state = null;
    this._route_load_signature = '';
    this._route_load = null;
    this._route_refresh_pending = false;
    this._browser_history_bound = false;
    this.image_overlay = null;
    this.profile_cache = {};

    // Per-view Manager chrome. Header is navigation only (back + title).
    // Home / notifications / user-content (posts/replies/likes) omit sticky chrome.
    // Thread keeps the pinned header for back navigation.
    this.viewChrome = {
      timeline: {
        header: false
      },
      notifications: {
        header: false
      },
      thread: {
        header: true
      },
      posts: {
        header: false
      },
      replies: {
        header: false
      },
      likes: {
        header: false
      }
    };
  }
  return _createClass(Manager, [{
    key: "createPaginationState",
    value: function createPaginationState() {
      return {
        timeline: {
          cursor: 0,
          batchSize: 5,
          loading: false,
          exhausted: false,
          mockPage: 0
        },
        notifications: {
          cursor: 0,
          batchSize: 2,
          loading: false,
          exhausted: false,
          mockPage: 0
        },
        thread: {
          cursor: 0,
          batchSize: 2,
          loading: false,
          exhausted: false,
          mockPage: 0,
          chain: []
        },
        posts: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false
        },
        replies: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false
        },
        likes: {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false
        }
      };
    }
  }, {
    key: "renderTimeline",
    value: function renderTimeline() {
      var _this$mod$main, _this$mod$main$showPr;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$updateHistory = _ref.updateHistory,
        updateHistory = _ref$updateHistory === void 0 ? true : _ref$updateHistory,
        _ref$scrollToTop = _ref.scrollToTop,
        scrollToTop = _ref$scrollToTop === void 0 ? false : _ref$scrollToTop;
      var previousMode = this.mode;
      this.clearPermalinkState();
      this.saveScrollPosition(previousMode);
      if (scrollToTop) {
        this.scroll_positions.timeline = 0;
      }
      this.mode = 'timeline';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      if (updateHistory) {
        this.replaceTweetLocation();
      }
      (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || (_this$mod$main$showPr = _this$mod$main.showProfile) === null || _this$mod$main$showPr === void 0 || _this$mod$main$showPr.call(_this$mod$main, this.mod.publicKey);
      this.render();
      if (previousMode !== 'timeline') {
        this.resetMenuToHome();
      }
      this.restoreScrollPosition('timeline');
      this.syncScrollFooter();
      this.syncPendingNewerTweets();
    }
  }, {
    key: "renderHome",
    value: function renderHome() {
      var scrollToTop = this.mode === 'timeline';
      this.pending_route_signature = '';
      this.replaceTweetLocation({
        force: true
      });
      this.renderTimeline({
        updateHistory: false,
        scrollToTop: scrollToTop
      });
    }
  }, {
    key: "renderNotifications",
    value: function renderNotifications() {
      var _this$mod$markNotific, _this$mod, _this$mod$main2, _this$mod$main2$showP;
      this.clearPermalinkState();
      this.saveScrollPosition();
      (_this$mod$markNotific = (_this$mod = this.mod).markNotificationsViewed) === null || _this$mod$markNotific === void 0 || _this$mod$markNotific.call(_this$mod);
      this.mode = 'notifications';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      (_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 || (_this$mod$main2$showP = _this$mod$main2.showProfile) === null || _this$mod$main2$showP === void 0 || _this$mod$main2$showP.call(_this$mod$main2, this.mod.publicKey);
      this.replaceTweetLocation();
      this.render();
      this.restoreScrollPosition('notifications');
      this.syncScrollFooter();
    }
  }, {
    key: "renderThread",
    value: function renderThread(signature) {
      var _this$mod$main3, _this$mod$main3$showP;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$updateHistory = _ref2.updateHistory,
        updateHistory = _ref2$updateHistory === void 0 ? true : _ref2$updateHistory;
      var previousMode = this.mode;
      this.clearPermalinkState();
      this.saveScrollPosition();
      var tweet = this.mod.getTweet(signature);
      this.mode = 'thread';
      this.active_signature = signature || '';
      this.active_thread_id = tweet ? tweet.thread_id || tweet.signature : '';
      this.active_profile_key = '';
      (_this$mod$main3 = this.mod.main) === null || _this$mod$main3 === void 0 || (_this$mod$main3$showP = _this$mod$main3.showProfile) === null || _this$mod$main3$showP === void 0 || _this$mod$main3$showP.call(_this$mod$main3, this.mod.publicKey);
      this.scroll_positions.thread = 0;
      if (updateHistory && signature && typeof window !== 'undefined') {
        var url = this.mod.returnTweetUrl(signature);
        var state = {
          redsquareView: 'thread',
          signature: signature
        };
        if (previousMode === 'thread') {
          window.history.replaceState(state, '', url);
        } else {
          window.history.pushState(state, '', url);
        }
      }
      this.resetThreadPagination(signature);
      this.render();
      this.restoreScrollPosition('thread');
      this.syncScrollFooter();
    }
  }, {
    key: "renderPosts",
    value: function renderPosts() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('posts', publicKey, options);
    }
  }, {
    key: "renderReplies",
    value: function renderReplies() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('replies', publicKey, options);
    }
  }, {
    key: "renderLikes",
    value: function renderLikes() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.renderProfileView('likes', publicKey, options);
    }
  }, {
    key: "renderProfileView",
    value: function renderProfileView(mode) {
      var _this$mod$main4, _this$mod$main4$showP;
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref3$updateHistory = _ref3.updateHistory,
        updateHistory = _ref3$updateHistory === void 0 ? true : _ref3$updateHistory;
      var previousMode = this.mode;
      var previousProfileKey = this.active_profile_key;
      this.clearPermalinkState();
      this.saveScrollPosition();
      this.mode = mode;
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = publicKey || this.mod.publicKey || '';
      this.scroll_positions[mode] = 0;
      if (updateHistory && typeof window !== 'undefined') {
        var state = {
          redsquareView: 'profile',
          publicKey: this.active_profile_key,
          tab: mode
        };
        var url = this.mod.returnUserUrl(this.active_profile_key);
        if (this.isProfileViewMode(previousMode) && previousProfileKey === this.active_profile_key) {
          window.history.replaceState(state, '', url);
        } else {
          window.history.pushState(state, '', url);
        }
      }
      if (!this.pagination[mode]) {
        this.pagination[mode] = {
          cursor: 0,
          batchSize: 20,
          loading: false,
          exhausted: false
        };
      } else {
        this.pagination[mode].cursor = 0;
        this.pagination[mode].loading = false;
        this.pagination[mode].exhausted = false;
      }
      (_this$mod$main4 = this.mod.main) === null || _this$mod$main4 === void 0 || (_this$mod$main4$showP = _this$mod$main4.showProfile) === null || _this$mod$main4$showP === void 0 || _this$mod$main4$showP.call(_this$mod$main4, this.active_profile_key);
      this.clearPrimaryNavigation();
      this.render();
      this.restoreScrollPosition(mode);
      this.syncFeedStatus();
    }
  }, {
    key: "isProfileViewMode",
    value: function isProfileViewMode() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      return mode === 'posts' || mode === 'replies' || mode === 'likes';
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.ensureShell();
      this.updateModeVisibility();
      switch (this.mode) {
        case 'thread':
          this.paintThread();
          break;
        case 'notifications':
          this.paintNotifications();
          break;
        case 'posts':
        case 'replies':
        case 'likes':
          this.paintProfileView();
          break;
        case 'timeline':
        default:
          this.paintTimeline();
          break;
      }
      this.syncFeedHeader();
      this.attachEvents();
      this.syncScrollFooter();
      this.syncProfileNav();

      // Remounts (e.g. main.render → menu.render) restore Home as active by default;
      // re-clear so user-content views never leave primary nav highlighted.
      if (this.isProfileMode()) {
        this.clearPrimaryNavigation();
      }
    }
  }, {
    key: "ensureShell",
    value: function ensureShell() {
      var root = document.querySelector(this.container);
      if (root && root.querySelector('.body') && root.querySelector('.list[data-panel="timeline"]') && root.querySelector('.list[data-panel="profile"]')) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(ManagerTemplate(), this.container);
      this.timeline_rendered = false;
      this.notifications_rendered = false;
      this.pagination = this.createPaginationState();
      this.pending_newer_tweets = [];
      this._timeline_bootstrapping = false;
      this._notifications_bootstrapping = false;
    }
  }, {
    key: "updateModeVisibility",
    value: function updateModeVisibility() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var timeline = root.querySelector('.list[data-panel="timeline"]');
      var thread = root.querySelector('.list[data-panel="thread"]');
      var notifications = root.querySelector('.list[data-panel="notifications"]');
      var profile = root.querySelector('.list[data-panel="profile"]');
      var profileModes = this.mode === 'posts' || this.mode === 'replies' || this.mode === 'likes';
      if (timeline) {
        timeline.hidden = this.mode !== 'timeline';
      }
      if (thread) {
        thread.hidden = this.mode !== 'thread';
      }
      if (notifications) {
        notifications.hidden = this.mode !== 'notifications';
      }
      if (profile) {
        profile.hidden = !profileModes;
      }
      if (this.mode !== 'timeline') {
        this.hideNewPostsBanner();
      } else if (this.pending_newer_tweets.length) {
        this.showNewPostsBanner();
      }
      this.syncFeedHeader();
    }

    /**
     * Feed-header chrome — mounted only when the active view needs navigation.
     * Creation lives in the sidebar Create component, not here.
     */
  }, {
    key: "syncFeedHeader",
    value: function syncFeedHeader() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var showHeader = this.requiresHeader();
      var header = root.querySelector(':scope > .header');
      if (showHeader) {
        var _header, _header2;
        if (!header) {
          var body = root.querySelector(':scope > .body');
          if (body) {
            body.insertAdjacentHTML('beforebegin', ManagerHeaderTemplate());
          } else {
            root.insertAdjacentHTML('afterbegin', ManagerHeaderTemplate());
          }
          header = root.querySelector(':scope > .header');
        }
        var title = (_header = header) === null || _header === void 0 ? void 0 : _header.querySelector('.title');
        var back = (_header2 = header) === null || _header2 === void 0 ? void 0 : _header2.querySelector('.back');

        // Only views with viewChrome.header === true reach here (currently: thread).
        var labels = {
          timeline: 'Home',
          notifications: 'Notifications',
          thread: 'Post'
        };
        if (title) {
          title.textContent = labels[this.mode] || 'Home';
          title.hidden = false;
        }
        var isDetail = this.isDetailHeaderMode();
        var showBack = this.mode !== 'timeline';
        if (back) {
          back.hidden = !showBack;
          back.setAttribute('aria-hidden', showBack ? 'false' : 'true');
        }
        root.classList.toggle('has-back', showBack);
        root.classList.toggle('detail', isDetail);
        root.classList.toggle('timeline', !isDetail);
      } else if (header) {
        header.remove();
        root.classList.remove('has-back', 'detail');
        root.classList.add('timeline');
      }
      root.classList.toggle('has-header', showHeader);
    }

    /**
     * Whether the active view requires Manager header chrome (back + title).
     * Driven by `viewChrome.header` on all viewports.
     */
  }, {
    key: "requiresHeader",
    value: function requiresHeader() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var chrome = this.viewChrome[mode];
      if (chrome && typeof chrome.header === 'boolean') {
        return chrome.header;
      }

      // Unknown views keep the header (navigation/context by default).
      return true;
    }
  }, {
    key: "isCompactViewport",
    value: function isCompactViewport() {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
      }
      return window.matchMedia('(max-width: 600px)').matches;
    }

    /**
     * Detail views show Back; thread is the primary detail case.
     */
  }, {
    key: "isDetailHeaderMode",
    value: function isDetailHeaderMode() {
      return this.mode === 'thread';
    }
  }, {
    key: "syncProfileNav",
    value: function syncProfileNav() {
      var _this$mod$main5, _this$mod$main6;
      (_this$mod$main5 = this.mod.main) === null || _this$mod$main5 === void 0 || (_this$mod$main5 = _this$mod$main5.profile) === null || _this$mod$main5 === void 0 || _this$mod$main5.syncActiveNav(this.mode);
      (_this$mod$main6 = this.mod.main) === null || _this$mod$main6 === void 0 || (_this$mod$main6 = _this$mod$main6.mobile_profile) === null || _this$mod$main6 === void 0 || _this$mod$main6.syncActiveNav(this.mode);
    }
  }, {
    key: "navigateBackToTimeline",
    value: function navigateBackToTimeline() {
      var _window$history$state, _window$history$state2;
      if (typeof window !== 'undefined' && (((_window$history$state = window.history.state) === null || _window$history$state === void 0 ? void 0 : _window$history$state.redsquareView) === 'thread' || ((_window$history$state2 = window.history.state) === null || _window$history$state2 === void 0 ? void 0 : _window$history$state2.redsquareView) === 'profile')) {
        window.history.back();
        return;
      }
      this.replaceTweetLocation();
      this.renderTimeline({
        updateHistory: false
      });
    }
  }, {
    key: "replaceTweetLocation",
    value: function replaceTweetLocation() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$force = _ref4.force,
        force = _ref4$force === void 0 ? false : _ref4$force;
      if (typeof window === 'undefined' || !force && !this.mod.returnTweetSignatureFromLocation() && !this.mod.returnUserPublicKeyFromLocation()) {
        return;
      }
      window.history.replaceState({
        redsquareView: 'timeline'
      }, '', "/".concat(encodeURI(this.mod.returnSlug()), "/"));
    }
  }, {
    key: "attachBrowserHistory",
    value: function attachBrowserHistory() {
      var _this = this;
      if (typeof window === 'undefined' || this._browser_history_bound) {
        return;
      }
      this._browser_history_bound = true;
      window.addEventListener('popstate', function () {
        _this.applyLocationRoute();
      });
    }
  }, {
    key: "applyLocationRoute",
    value: function () {
      var _applyLocationRoute = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var _ref5,
          _ref5$refresh,
          refresh,
          signature,
          publicKey,
          _this$app$crypto,
          _window$history,
          canonicalPath,
          historyTab,
          requestedTab,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref5 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref5$refresh = _ref5.refresh, refresh = _ref5$refresh === void 0 ? false : _ref5$refresh;
              signature = this.mod.returnTweetSignatureFromLocation();
              publicKey = this.mod.returnUserPublicKeyFromLocation();
              if (!(publicKey && !signature)) {
                _context.n = 3;
                break;
              }
              this.clearPermalinkState();
              if (!((_this$app$crypto = this.app.crypto) !== null && _this$app$crypto !== void 0 && _this$app$crypto.isPublicKey && !this.app.crypto.isPublicKey(publicKey))) {
                _context.n = 1;
                break;
              }
              this.renderTimeline({
                updateHistory: false
              });
              return _context.a(2, null);
            case 1:
              canonicalPath = "/".concat(encodeURI(this.mod.returnSlug()), "/user/").concat(encodeURIComponent(publicKey));
              historyTab = typeof window !== 'undefined' ? (_window$history = window.history) === null || _window$history === void 0 || (_window$history = _window$history.state) === null || _window$history === void 0 ? void 0 : _window$history.tab : '';
              requestedTab = ['posts', 'replies', 'likes'].includes(historyTab) ? historyTab : this.isProfileMode() && this.active_profile_key === publicKey ? this.mode : 'posts';
              if (typeof window !== 'undefined' && window.location.pathname !== canonicalPath) {
                window.history.replaceState({
                  redsquareView: 'profile',
                  publicKey: publicKey,
                  tab: requestedTab
                }, '', this.mod.returnUserUrl(publicKey));
              }
              if (!(!refresh && this.isProfileMode() && this.active_profile_key === publicKey)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, publicKey);
            case 2:
              this.renderProfileView(requestedTab, publicKey, {
                updateHistory: false
              });
              return _context.a(2, publicKey);
            case 3:
              if (signature) {
                _context.n = 4;
                break;
              }
              this.clearPermalinkState();
              if (this.mode === 'thread' || this.isProfileMode()) {
                this.renderTimeline({
                  updateHistory: false
                });
              }
              return _context.a(2, null);
            case 4:
              if (!(!refresh && this.mode === 'thread' && this.active_signature === signature)) {
                _context.n = 5;
                break;
              }
              return _context.a(2, this.mod.getTweet(signature));
            case 5:
              if (!(this._route_load && this._route_load_signature === signature)) {
                _context.n = 6;
                break;
              }
              if (refresh) {
                this._route_refresh_pending = true;
              }
              return _context.a(2, this._route_load);
            case 6:
              this.pending_route_signature = signature;
              this._route_load_signature = signature;
              if (!this.mod.getTweet(signature)) {
                this.renderPermalinkState(signature, 'loading');
              }
              this._route_load = this.mod.loadTweetThread(signature).then(function (result) {
                if (_this2.mod.returnTweetSignatureFromLocation() !== signature) {
                  return result;
                }
                if ((result === null || result === void 0 ? void 0 : result.status) === 'loaded' && result.tweet) {
                  _this2.pending_route_signature = '';
                  _this2.renderThread(signature, {
                    updateHistory: false
                  });
                } else {
                  var status = (result === null || result === void 0 ? void 0 : result.status) === 'unavailable' ? 'unavailable' : 'error';
                  _this2.renderPermalinkState(signature, status, result === null || result === void 0 ? void 0 : result.reason);
                }
                return result;
              })["catch"](function (err) {
                console.error('RedSquare shared tweet lookup failed:', err);
                if (_this2.mod.returnTweetSignatureFromLocation() === signature) {
                  _this2.renderPermalinkState(signature, 'error', 'lookup-failed');
                }
                return {
                  status: 'error',
                  reason: 'lookup-failed',
                  tweet: null
                };
              })["finally"](function () {
                if (_this2._route_load_signature === signature) {
                  var refreshPending = _this2._route_refresh_pending;
                  _this2._route_load_signature = '';
                  _this2._route_load = null;
                  _this2._route_refresh_pending = false;
                  if (refreshPending && _this2.mod.returnTweetSignatureFromLocation() === signature) {
                    setTimeout(function () {
                      if (!_this2._route_load && _this2.mod.returnTweetSignatureFromLocation() === signature) {
                        _this2.applyLocationRoute({
                          refresh: true
                        });
                      }
                    }, 0);
                  }
                }
              });
              return _context.a(2, this._route_load);
          }
        }, _callee, this);
      }));
      function applyLocationRoute() {
        return _applyLocationRoute.apply(this, arguments);
      }
      return applyLocationRoute;
    }()
  }, {
    key: "clearPermalinkState",
    value: function clearPermalinkState() {
      this.pending_route_signature = '';
      this.permalink_state = null;
      this._route_refresh_pending = false;
    }
  }, {
    key: "renderPermalinkState",
    value: function renderPermalinkState(signature, status) {
      var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this.mode = 'thread';
      this.active_signature = signature || '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      this.pending_route_signature = signature || '';
      this.permalink_state = {
        signature: signature,
        status: status,
        reason: reason
      };
      this.pagination.thread = _objectSpread(_objectSpread({}, this.createPaginationState().thread), {}, {
        loading: status === 'loading',
        exhausted: status !== 'loading',
        chain: []
      });
      this.render();
    }
  }, {
    key: "getScrollContainer",
    value: function getScrollContainer() {
      return document.querySelector("".concat(this.container, " .body")) || document.querySelector('.manager .body') || document.querySelector(this.container) || document.querySelector('#saito-container') || document.querySelector('.saito-container');
    }
  }, {
    key: "saveScrollPosition",
    value: function saveScrollPosition() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var scroller = this.getScrollContainer();
      if (!scroller || !mode || !this.scroll_positions) {
        return;
      }
      this.scroll_positions[mode] = scroller.scrollTop;
    }
  }, {
    key: "restoreScrollPosition",
    value: function restoreScrollPosition() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mode;
      var scroller = this.getScrollContainer();
      if (!scroller || !mode || !this.scroll_positions) {
        return;
      }
      var scrollTop = this.scroll_positions[mode] || 0;
      requestAnimationFrame(function () {
        scroller.scrollTop = scrollTop;
      });
    }
  }, {
    key: "resetMenuToHome",
    value: function resetMenuToHome() {
      var _this$mod$main7;
      var homeItem = document.querySelector('.sidebar-left .menu [data-nav="home"]');
      if (homeItem && (_this$mod$main7 = this.mod.main) !== null && _this$mod$main7 !== void 0 && _this$mod$main7.menu) {
        this.mod.main.menu.setActiveMenuItem(homeItem);
      }
    }

    /**
     * User-content views are not primary navigation destinations.
     * Clear Home / Notifications / etc. selection while posts/replies/likes are shown.
     */
  }, {
    key: "clearPrimaryNavigation",
    value: function clearPrimaryNavigation() {
      var _this$mod$main8, _this$mod$main8$clear;
      (_this$mod$main8 = this.mod.main) === null || _this$mod$main8 === void 0 || (_this$mod$main8 = _this$mod$main8.menu) === null || _this$mod$main8 === void 0 || (_this$mod$main8$clear = _this$mod$main8.clearActiveMenuItem) === null || _this$mod$main8$clear === void 0 || _this$mod$main8$clear.call(_this$mod$main8);
    }
  }, {
    key: "getPaginationState",
    value: function getPaginationState() {
      return this.pagination[this.mode] || this.pagination.timeline;
    }
  }, {
    key: "getEndMessage",
    value: function getEndMessage() {
      return this.getFeedStatusMessage('end');
    }
  }, {
    key: "getFeedStatusMessage",
    value: function getFeedStatusMessage(status) {
      var _this$permalink_state, _messages$this$mode;
      if (this.mode === 'thread' && ((_this$permalink_state = this.permalink_state) === null || _this$permalink_state === void 0 ? void 0 : _this$permalink_state.status) === status) {
        if (status === 'unavailable' && this.permalink_state.reason === 'rejected') {
          return 'This tweet was found but could not be displayed.';
        }
        if (status === 'unavailable') {
          return 'This tweet is not available from your local archive or connected RedSquare peers.';
        }
        if (status === 'error') {
          return 'RedSquare could not check every available archive for this tweet.';
        }
      }
      var messages = {
        timeline: {
          loading: 'Loading tweets...',
          empty: 'No tweets yet.',
          end: 'No more tweets.'
        },
        notifications: {
          loading: 'Loading notifications...',
          empty: "You're all caught up",
          end: 'No more notifications.'
        },
        thread: {
          loading: 'Loading replies...',
          empty: 'No replies.',
          end: 'No more replies.'
        },
        posts: {
          loading: 'Loading posts...',
          empty: 'No posts yet.',
          end: 'No more posts.'
        },
        replies: {
          loading: 'Loading replies...',
          empty: 'No replies.',
          end: 'No more replies.'
        },
        likes: {
          loading: 'Loading likes...',
          empty: 'No liked posts.',
          end: 'No more liked posts.'
        }
      };
      return ((_messages$this$mode = messages[this.mode]) === null || _messages$this$mode === void 0 ? void 0 : _messages$this$mode[status]) || '';
    }
  }, {
    key: "isProfileMode",
    value: function isProfileMode() {
      return this.mode === 'posts' || this.mode === 'replies' || this.mode === 'likes';
    }
  }, {
    key: "getActivePanelElement",
    value: function getActivePanelElement() {
      var root = document.querySelector(this.container);
      if (!root) {
        return null;
      }
      switch (this.mode) {
        case 'thread':
          return root.querySelector('.list[data-panel="thread"]');
        case 'notifications':
          return root.querySelector('.list[data-panel="notifications"]');
        case 'posts':
        case 'replies':
        case 'likes':
          return root.querySelector('.list[data-panel="profile"]');
        case 'timeline':
        default:
          return root.querySelector('.list[data-panel="timeline"]');
      }
    }
  }, {
    key: "getActivePanelSelector",
    value: function getActivePanelSelector() {
      switch (this.mode) {
        case 'thread':
          return "".concat(this.container, " .list[data-panel=\"thread\"]");
        case 'notifications':
          return "".concat(this.container, " .list[data-panel=\"notifications\"]");
        case 'posts':
        case 'replies':
        case 'likes':
          return "".concat(this.container, " .list[data-panel=\"profile\"]");
        case 'timeline':
        default:
          return "".concat(this.container, " .list[data-panel=\"timeline\"]");
      }
    }
  }, {
    key: "clearPanel",
    value: function clearPanel(selector) {
      var panel = document.querySelector(selector);
      if (panel) {
        panel.innerHTML = '';
      }
    }
  }, {
    key: "paintTimeline",
    value: function paintTimeline() {
      if (this.timeline_rendered || this._timeline_bootstrapping) {
        this.syncFeedStatus();
        return;
      }
      this.bootstrapTimeline();
    }
  }, {
    key: "bootstrapTimeline",
    value: function () {
      var _bootstrapTimeline = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(this.timeline_rendered || this._timeline_bootstrapping)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this._timeline_bootstrapping = true;
              this.syncFeedStatus();
              if (!this.timeline_rendered) {
                _context2.n = 2;
                break;
              }
              this._timeline_bootstrapping = false;
              this.syncFeedStatus();
              return _context2.a(2);
            case 2:
              this.appendTimelineBatch();
              this.timeline_rendered = true;
              this._timeline_bootstrapping = false;
              this.syncFeedStatus();
              this.fetchRemoteTransactions('tweets', 'newer');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function bootstrapTimeline() {
        return _bootstrapTimeline.apply(this, arguments);
      }
      return bootstrapTimeline;
    }()
  }, {
    key: "paintThread",
    value: function paintThread() {
      var container = "".concat(this.container, " .list[data-panel=\"thread\"]");
      this.clearPanel(container);
      this.renderThreadContextLink(container);
      this.appendThreadBatch();
      this.syncFeedStatus();
    }
  }, {
    key: "renderThreadContextLink",
    value: function renderThreadContextLink(container) {
      var focused = this.mod.getTweet(this.active_signature);
      if (!(focused !== null && focused !== void 0 && focused.parent_id)) {
        return;
      }
      var parent = this.mod.getTweet(focused.parent_id);
      if (!parent) {
        return;
      }
      var root = this.getThreadRoot(this.active_signature);
      var html = "\n      <div class=\"thread-context\" role=\"button\" tabindex=\"0\" data-root=\"".concat(root, "\">\n        View entire thread\n      </div>\n    ");
      this.app.browser.addElementToSelector(html, container);
    }
  }, {
    key: "paintNotifications",
    value: function paintNotifications() {
      if (this.notifications_rendered || this._notifications_bootstrapping) {
        this.renderModerateQueue();
        this.syncFeedStatus();
        return;
      }
      this.bootstrapNotifications();
    }
  }, {
    key: "renderModerateQueue",
    value: function renderModerateQueue() {
      if (!this.mod.moderator_mode || !this.mod.moderate) {
        return;
      }
      this.mod.moderate.render(this.getActivePanelSelector());
    }
  }, {
    key: "bootstrapNotifications",
    value: function () {
      var _bootstrapNotifications = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var state;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(this.notifications_rendered || this._notifications_bootstrapping)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this._notifications_bootstrapping = true;
              this.syncFeedStatus();
              this.renderModerateQueue();
              this.appendNotificationsBatch();
              _context3.n = 2;
              return this.loadNotificationDirection('newer');
            case 2:
              if (!(this.getRenderedItemCount() === 0)) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return this.loadNotificationDirection('older');
            case 3:
              this.notifications_rendered = true;
              this._notifications_bootstrapping = false;
              state = this.pagination.notifications;
              if (this.getRenderedItemCount() === 0) {
                state.loading = false;
                state.exhausted = true;
              }
              this.syncFeedStatus();
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function bootstrapNotifications() {
        return _bootstrapNotifications.apply(this, arguments);
      }
      return bootstrapNotifications;
    }()
  }, {
    key: "loadNotificationDirection",
    value: function loadNotificationDirection(direction) {
      var _this3 = this;
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function finish(result) {
          if (settled) {
            return;
          }
          settled = true;
          if (direction === 'newer') {
            _this3.handleNewerNotifications(result || {
              type: 'notifications',
              direction: 'newer',
              added: [],
              updated: [],
              ignored: [],
              exhausted: true
            });
          } else {
            _this3.applyOlderLoadResult(result || {
              type: 'notifications',
              direction: 'older',
              added: [],
              updated: [],
              ignored: [],
              exhausted: true
            });
          }
          resolve();
        };
        var timer = setTimeout(function () {
          finish({
            type: 'notifications',
            direction: direction,
            added: [],
            updated: [],
            ignored: [],
            exhausted: true
          });
        }, 12000);
        try {
          _this3.mod.loadTransactions('notifications', direction, function (result) {
            clearTimeout(timer);
            finish(result);
          });
        } catch (err) {
          clearTimeout(timer);
          finish({
            type: 'notifications',
            direction: direction,
            added: [],
            updated: [],
            ignored: [],
            exhausted: true
          });
        }
      });
    }
  }, {
    key: "paintProfileView",
    value: function paintProfileView() {
      var container = this.getActivePanelSelector();
      this.clearPanel(container);
      if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 820px)').matches) {
        var _this$mod$main9, _this$mod$main9$showM;
        this.app.browser.addElementToSelector('<section class="redsquare-profile mobile"></section>', container);
        (_this$mod$main9 = this.mod.main) === null || _this$mod$main9 === void 0 || (_this$mod$main9$showM = _this$mod$main9.showMobileProfile) === null || _this$mod$main9$showM === void 0 || _this$mod$main9$showM.call(_this$mod$main9, this.active_profile_key);
      }
      this.appendProfileBatch();
      var state = this.getPaginationState();
      var source = this.getActiveProfileSource();
      state.exhausted = Boolean((source === null || source === void 0 ? void 0 : source.exhausted) && state.cursor >= this.collectProfileTweets().length);
      this.syncFeedStatus();
      if (!state.exhausted && this.isNearBottom()) {
        this.loadMore();
      }
    }
  }, {
    key: "createProfileSourceState",
    value: function createProfileSourceState() {
      return {
        loading: false,
        exhausted: false,
        peers: {}
      };
    }
  }, {
    key: "getProfileCache",
    value: function getProfileCache() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active_profile_key;
      var key = publicKey || '';
      if (!this.profile_cache[key]) {
        var cache = {
          posts: [],
          replies: [],
          likes: [],
          postSet: new Set(),
          replySet: new Set(),
          likeSet: new Set(),
          author: this.createProfileSourceState(),
          likesSource: this.createProfileSourceState()
        };
        for (var _i = 0, _Object$values = Object.values(this.mod.tweets || {}); _i < _Object$values.length; _i++) {
          var tweet = _Object$values[_i];
          if ((tweet === null || tweet === void 0 ? void 0 : tweet.publicKey) === key) {
            this.addTweetToProfileCache(cache, tweet, tweet.parent_id ? 'replies' : 'posts');
          }
          if (Array.isArray(tweet === null || tweet === void 0 ? void 0 : tweet.likers) && tweet.likers.includes(key)) {
            this.addTweetToProfileCache(cache, tweet, 'likes');
          }
        }
        this.profile_cache[key] = cache;
      }
      return this.profile_cache[key];
    }
  }, {
    key: "addTweetToProfileCache",
    value: function addTweetToProfileCache(cache, tweet, mode) {
      var _this4 = this;
      var signature = (tweet === null || tweet === void 0 ? void 0 : tweet.signature) || '';
      var setName = mode === 'posts' ? 'postSet' : mode === 'replies' ? 'replySet' : 'likeSet';
      if (!signature || cache[setName].has(signature)) {
        return false;
      }
      cache[setName].add(signature);
      cache[mode].push(signature);
      cache[mode].sort(function (a, b) {
        var first = _this4.mod.getTweet(a);
        var second = _this4.mod.getTweet(b);
        return (Number(second === null || second === void 0 ? void 0 : second.created_at) || 0) - (Number(first === null || first === void 0 ? void 0 : first.created_at) || 0);
      });
      return true;
    }
  }, {
    key: "getActiveProfileSource",
    value: function getActiveProfileSource() {
      var cache = this.getProfileCache();
      return this.mode === 'likes' ? cache.likesSource : cache.author;
    }
  }, {
    key: "returnProfilePeerKey",
    value: function returnProfilePeerKey(peer, index) {
      if (peer === 'localhost') {
        return 'localhost';
      }
      return (peer === null || peer === void 0 ? void 0 : peer.publicKey) || "peer-".concat(index);
    }
  }, {
    key: "loadProfileArchivePage",
    value: function () {
      var _loadProfileArchivePage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this$app$modules,
          _this$app$modules$mod,
          _this5 = this;
        var publicKey, mode, cache, source, limit, peers, requests, pages, added, signatures, _iterator, _step, txs, _iterator3, _step3, _this$app$modules2, _this$app$modules2$mo, _tx$returnMessage, _message$data, tx, message, signature, targetPages, tweets, _iterator2, _step2, tweet, _tweets, _iterator4, _step4, _tweet, _t, _t2, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              publicKey = this.active_profile_key || '';
              mode = this.mode;
              cache = this.getProfileCache(publicKey);
              source = mode === 'likes' ? cache.likesSource : cache.author;
              if (!(!publicKey || source.loading || source.exhausted)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, 0);
            case 1:
              if (!(((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$mod = _this$app$modules.moderateAddress) === null || _this$app$modules$mod === void 0 ? void 0 : _this$app$modules$mod.call(_this$app$modules, publicKey)) === -1)) {
                _context5.n = 2;
                break;
              }
              source.exhausted = true;
              return _context5.a(2, 0);
            case 2:
              source.loading = true;
              limit = 20;
              peers = this.mod.returnTweetArchivePeers();
              _context5.p = 3;
              requests = peers.map(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(peer, index) {
                  var peerKey, peerState, query, txs, timestamps;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        peerKey = _this5.returnProfilePeerKey(peer, index);
                        peerState = source.peers[peerKey] || {
                          cursor: Date.now() + 1,
                          exhausted: false
                        };
                        source.peers[peerKey] = peerState;
                        if (!peerState.exhausted) {
                          _context4.n = 1;
                          break;
                        }
                        return _context4.a(2, {
                          peer: peer,
                          txs: []
                        });
                      case 1:
                        query = {
                          field1: mode === 'likes' ? 'RedSquareLike' : 'RedSquare',
                          field2: publicKey,
                          created_earlier_than: peerState.cursor,
                          limit: limit
                        };
                        if (mode !== 'likes') {
                          query.flagged_ne = 1;
                        }
                        _context4.n = 2;
                        return _this5.mod.loadArchiveTransactions(query, peer);
                      case 2:
                        txs = _context4.v;
                        timestamps = txs.map(function (tx) {
                          return Number(tx === null || tx === void 0 ? void 0 : tx.timestamp) || 0;
                        }).filter(Boolean);
                        if (timestamps.length) {
                          peerState.cursor = Math.min.apply(Math, _toConsumableArray(timestamps));
                        }
                        if (txs.length < limit) {
                          peerState.exhausted = true;
                        }
                        return _context4.a(2, {
                          peer: peer,
                          txs: txs
                        });
                    }
                  }, _callee4);
                }));
                return function (_x, _x2) {
                  return _ref6.apply(this, arguments);
                };
              }());
              _context5.n = 4;
              return Promise.all(requests);
            case 4:
              pages = _context5.v;
              added = 0;
              if (!(mode === 'likes')) {
                _context5.n = 22;
                break;
              }
              signatures = new Set();
              _iterator = _createForOfIteratorHelper(pages);
              _context5.p = 5;
              _iterator.s();
            case 6:
              if ((_step = _iterator.n()).done) {
                _context5.n = 16;
                break;
              }
              txs = _step.value.txs;
              _iterator3 = _createForOfIteratorHelper(txs);
              _context5.p = 7;
              _iterator3.s();
            case 8:
              if ((_step3 = _iterator3.n()).done) {
                _context5.n = 12;
                break;
              }
              tx = _step3.value;
              if (!(typeof (tx === null || tx === void 0 ? void 0 : tx.decryptMessage) === 'function')) {
                _context5.n = 9;
                break;
              }
              _context5.n = 9;
              return tx.decryptMessage(this.app);
            case 9:
              if (!(((_this$app$modules2 = this.app.modules) === null || _this$app$modules2 === void 0 || (_this$app$modules2$mo = _this$app$modules2.moderate) === null || _this$app$modules2$mo === void 0 ? void 0 : _this$app$modules2$mo.call(_this$app$modules2, tx, this.mod.name)) === -1)) {
                _context5.n = 10;
                break;
              }
              return _context5.a(3, 11);
            case 10:
              message = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (tx === null || tx === void 0 ? void 0 : tx.msg) || {};
              signature = (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.signature;
              if (signature != null && String(signature)) {
                signatures.add(String(signature));
              }
            case 11:
              _context5.n = 8;
              break;
            case 12:
              _context5.n = 14;
              break;
            case 13:
              _context5.p = 13;
              _t = _context5.v;
              _iterator3.e(_t);
            case 14:
              _context5.p = 14;
              _iterator3.f();
              return _context5.f(14);
            case 15:
              _context5.n = 6;
              break;
            case 16:
              _context5.n = 18;
              break;
            case 17:
              _context5.p = 17;
              _t2 = _context5.v;
              _iterator.e(_t2);
            case 18:
              _context5.p = 18;
              _iterator.f();
              return _context5.f(18);
            case 19:
              _context5.n = 20;
              return Promise.all(Array.from(signatures).flatMap(function (signature) {
                return peers.map(function (peer) {
                  return _this5.mod.loadArchiveTransactions({
                    sig: signature,
                    field1: 'RedSquare',
                    flagged_ne: 1
                  }, peer);
                });
              }));
            case 20:
              targetPages = _context5.v;
              _context5.n = 21;
              return this.mod.cacheProfileTweetTransactions(targetPages.flat());
            case 21:
              tweets = _context5.v;
              _iterator2 = _createForOfIteratorHelper(tweets);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  tweet = _step2.value;
                  if (this.addTweetToProfileCache(cache, tweet, 'likes')) {
                    added++;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context5.n = 31;
              break;
            case 22:
              _context5.n = 23;
              return this.mod.cacheProfileTweetTransactions(pages.flatMap(function (_ref7) {
                var txs = _ref7.txs;
                return txs;
              }));
            case 23:
              _tweets = _context5.v;
              _iterator4 = _createForOfIteratorHelper(_tweets);
              _context5.p = 24;
              _iterator4.s();
            case 25:
              if ((_step4 = _iterator4.n()).done) {
                _context5.n = 28;
                break;
              }
              _tweet = _step4.value;
              if (!(_tweet.publicKey !== publicKey)) {
                _context5.n = 26;
                break;
              }
              return _context5.a(3, 27);
            case 26:
              if (this.addTweetToProfileCache(cache, _tweet, _tweet.parent_id ? 'replies' : 'posts')) {
                added++;
              }
            case 27:
              _context5.n = 25;
              break;
            case 28:
              _context5.n = 30;
              break;
            case 29:
              _context5.p = 29;
              _t3 = _context5.v;
              _iterator4.e(_t3);
            case 30:
              _context5.p = 30;
              _iterator4.f();
              return _context5.f(30);
            case 31:
              source.exhausted = Object.values(source.peers).every(function (peerState) {
                return peerState.exhausted;
              });
              return _context5.a(2, added);
            case 32:
              _context5.p = 32;
              source.loading = false;
              return _context5.f(32);
            case 33:
              return _context5.a(2);
          }
        }, _callee5, this, [[24, 29, 30, 31], [7, 13, 14, 15], [5, 17, 18, 19], [3,, 32, 33]]);
      }));
      function loadProfileArchivePage() {
        return _loadProfileArchivePage.apply(this, arguments);
      }
      return loadProfileArchivePage;
    }()
  }, {
    key: "appendProfileBatch",
    value: function appendProfileBatch() {
      var state = this.getPaginationState();
      var tweets = this.collectProfileTweets();
      var batch = tweets.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      var _iterator5 = _createForOfIteratorHelper(batch),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var tweet = _step5.value;
          tweet.render(container);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      state.cursor += batch.length;
      this.syncFeedStatus();
      return batch.length;
    }
  }, {
    key: "collectProfileTweets",
    value: function collectProfileTweets() {
      var _this$app$modules3,
        _this$app$modules3$mo,
        _this6 = this;
      if (((_this$app$modules3 = this.app.modules) === null || _this$app$modules3 === void 0 || (_this$app$modules3$mo = _this$app$modules3.moderateAddress) === null || _this$app$modules3$mo === void 0 ? void 0 : _this$app$modules3$mo.call(_this$app$modules3, this.active_profile_key)) === -1) {
        return [];
      }
      var cache = this.getProfileCache();
      return (cache[this.mode] || []).map(function (signature) {
        return _this6.mod.getTweet(signature);
      }).filter(Boolean);
    }
  }, {
    key: "appendTimelineBatch",
    value: function appendTimelineBatch() {
      var state = this.pagination.timeline;
      var signatures = this.mod.tweets_timeline.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      if (signatures.length === 0) {
        this.syncFeedStatus();
        return 0;
      }
      var _iterator6 = _createForOfIteratorHelper(signatures),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var signature = _step6.value;
          var tweet = this.mod.getTweet(signature);
          if (tweet) {
            this.renderTweetWithCriticalChild(tweet, container);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      state.cursor += signatures.length;
      this.syncFeedStatus();
      return signatures.length;
    }
  }, {
    key: "appendNotificationsBatch",
    value: function appendNotificationsBatch() {
      var state = this.pagination.notifications;
      var signatures = this.mod.notifications_timeline.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      if (signatures.length === 0) {
        this.syncFeedStatus();
        return 0;
      }
      var _iterator7 = _createForOfIteratorHelper(signatures),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var signature = _step7.value;
          var notification = this.mod.getNotification(signature);
          if (notification) {
            notification.render(container);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      state.cursor += signatures.length;
      this.syncFeedStatus();
      return signatures.length;
    }
  }, {
    key: "appendThreadBatch",
    value: function appendThreadBatch() {
      var state = this.pagination.thread;
      var signatures = state.chain.slice(state.cursor, state.cursor + state.batchSize);
      var container = this.getActivePanelSelector();
      if (signatures.length === 0) {
        if (state.cursor >= state.chain.length) {
          state.exhausted = true;
        }
        this.syncFeedStatus();
        return 0;
      }
      for (var i = 0; i < signatures.length; i++) {
        var signature = signatures[i];
        var tweet = this.mod.getTweet(signature);
        var globalIndex = state.cursor + i;
        if (!tweet) {
          continue;
        }
        var options = this.buildThreadRenderOptions(globalIndex, state.chain.length);
        tweet.render(container, options);
      }
      state.cursor += signatures.length;
      if (state.cursor >= state.chain.length) {
        state.exhausted = true;
      }
      this.syncFeedStatus();
      return signatures.length;
    }
  }, {
    key: "buildThreadRenderOptions",
    value: function buildThreadRenderOptions(globalIndex, chainLength) {
      var options = {};
      if (globalIndex === 0) {
        options.focused = true;
        options.presentation = 'focused';
      } else {
        options.reply = true;
        options.presentation = 'reply';
        options.chainPrev = true;
      }
      if (globalIndex < chainLength - 1) {
        options.chainNext = true;
        options.chainContinue = true;
      }
      return options;
    }
  }, {
    key: "appendLoadedItems",
    value: function appendLoadedItems(result) {
      var container = this.getActivePanelSelector();
      var state = this.getPaginationState();
      var signatures = result.added || [];
      if (this.mode === 'notifications') {
        var _iterator8 = _createForOfIteratorHelper(signatures),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var signature = _step8.value;
            var notification = this.mod.getNotification(signature);
            if (notification) {
              notification.render(container);
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
        state.cursor += signatures.length;
        return;
      }
      if (this.mode === 'thread') {
        var startIndex = state.cursor;
        for (var i = 0; i < signatures.length; i++) {
          var _signature = signatures[i];
          var tweet = this.mod.getTweet(_signature);
          var globalIndex = startIndex + i;
          if (!tweet) {
            continue;
          }
          tweet.render(container, this.buildThreadRenderOptions(globalIndex, state.chain.length));
        }
        state.cursor += signatures.length;
        return;
      }
      var _iterator9 = _createForOfIteratorHelper(signatures),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _signature2 = _step9.value;
          var _tweet2 = this.mod.getTweet(_signature2);
          if (!_tweet2 || _tweet2.parent_id) {
            continue;
          }
          this.renderTweetWithCriticalChild(_tweet2, container);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      state.cursor += signatures.length;
    }
  }, {
    key: "resetThreadPagination",
    value: function resetThreadPagination(signature) {
      var chain = this.buildThreadView(signature);
      this.pagination.thread = _objectSpread(_objectSpread({}, this.createPaginationState().thread), {}, {
        batchSize: Math.max(this.createPaginationState().thread.batchSize, chain.length),
        chain: chain
      });
    }
  }, {
    key: "buildThreadView",
    value: function buildThreadView(signature) {
      var _this7 = this;
      if (!signature) {
        return [];
      }
      var chain = [];
      var visited = new Set();
      var _visit = function visit(currentSignature) {
        if (visited.has(currentSignature)) {
          return;
        }
        visited.add(currentSignature);
        if (!_this7.mod.getTweet(currentSignature)) {
          return;
        }
        chain.push(currentSignature);
        var _iterator0 = _createForOfIteratorHelper(_this7.getDirectReplies(currentSignature)),
          _step0;
        try {
          for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
            var childSignature = _step0.value;
            _visit(childSignature);
          }
        } catch (err) {
          _iterator0.e(err);
        } finally {
          _iterator0.f();
        }
      };
      _visit(signature);
      return chain;
    }
  }, {
    key: "getDirectReplies",
    value: function getDirectReplies(parentSignature) {
      var _this$mod$tweets_chil,
        _this8 = this;
      var children = new Set(((_this$mod$tweets_chil = this.mod.tweets_children) === null || _this$mod$tweets_chil === void 0 ? void 0 : _this$mod$tweets_chil[parentSignature]) || []);

      // Reconstruct missing index entries from the tweets themselves. Archive
      // batches can arrive in any order, but a loaded reply must never disappear
      // when switching from a focused reply to the complete thread.
      for (var _i2 = 0, _Object$values2 = Object.values(this.mod.tweets || {}); _i2 < _Object$values2.length; _i2++) {
        var tweet = _Object$values2[_i2];
        if ((tweet === null || tweet === void 0 ? void 0 : tweet.parent_id) === parentSignature && tweet.signature) {
          children.add(tweet.signature);
        }
      }
      return _toConsumableArray(children).map(function (sig) {
        return _this8.mod.getTweet(sig);
      }).filter(Boolean).sort(function (a, b) {
        var timestampDifference = (a.created_at || 0) - (b.created_at || 0);
        return timestampDifference || a.signature.localeCompare(b.signature);
      }).map(function (tweet) {
        return tweet.signature;
      });
    }
  }, {
    key: "getThreadRoot",
    value: function getThreadRoot(signature) {
      var root = signature;
      var visited = new Set([root]);
      while ((_this$mod$tweets_pare = this.mod.tweets_parents) !== null && _this$mod$tweets_pare !== void 0 && _this$mod$tweets_pare[root]) {
        var _this$mod$tweets_pare;
        var parent = this.mod.tweets_parents[root];
        if (visited.has(parent) || !this.mod.getTweet(parent)) {
          break;
        }
        visited.add(parent);
        root = parent;
      }
      return root;
    }

    //
    // Compose integration — Manager owns all post-submit rendering
    //
  }, {
    key: "onTweetPosted",
    value: function onTweetPosted(tweet) {
      if (!tweet) {
        return;
      }
      var isReply = Boolean(tweet.parent_id);
      if (this.mode === 'thread' && isReply && tweet.parent_id === this.active_signature) {
        this.insertThreadReply(tweet);
        return;
      }
      if (this.mode !== 'timeline') {
        if (isReply) {
          this.openThreadForPostedReply(tweet);
          return;
        }
        this.renderTimelineForNewPost();
      }
      if (!isReply) {
        this.insertTimelineTweet(tweet);
      }
    }
  }, {
    key: "onTweetDeleted",
    value: function onTweetDeleted(signature) {
      if (!signature) {
        return;
      }
      document.querySelectorAll("article.tweet[data-id=\"".concat(signature, "\"]")).forEach(function (el) {
        return el.remove();
      });
      if (this.mode === 'thread' && this.active_signature === signature) {
        this.renderTimelineForNewPost();
      }
    }
  }, {
    key: "renderTimelineForNewPost",
    value: function renderTimelineForNewPost() {
      var _this9 = this;
      this.saveScrollPosition();
      this.mode = 'timeline';
      this.active_signature = '';
      this.active_thread_id = '';
      this.active_profile_key = '';
      this.replaceTweetLocation();
      this.scroll_positions.timeline = 0;
      this.updateModeVisibility();
      this.syncFeedHeader();
      this.resetMenuToHome();
      this.syncProfileNav();
      if (!this.timeline_rendered) {
        this.paintTimeline();
      }
      this.syncScrollFooter();
      requestAnimationFrame(function () {
        var scroller = _this9.getScrollContainer();
        if (scroller) {
          scroller.scrollTop = 0;
        }
      });
    }
  }, {
    key: "openThreadForPostedReply",
    value: function openThreadForPostedReply(tweet) {
      if (!tweet) {
        return;
      }
      this.renderThread(tweet.signature);
    }
  }, {
    key: "insertTimelineTweet",
    value: function insertTimelineTweet(tweet) {
      if (!tweet || tweet.parent_id) {
        return;
      }
      var container = "".concat(this.container, " .list[data-panel=\"timeline\"]");
      var panel = document.querySelector(container);
      if (!panel) {
        return;
      }
      var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
      var options = {};
      if (child) {
        options.chainNext = true;
        options.chainContinue = true;
        options.presentation = 'root';
        options.root = true;
      }
      var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
      this.app.browser.prependElementToSelector(html, container);
      this.pagination.timeline.cursor += 1;
      this.timeline_rendered = true;
      if (child) {
        var childOptions = {
          chainPrev: true,
          presentation: 'reply',
          reply: true
        };
        var childHtml = TweetTemplate(child, child.buildClassName(childOptions), childOptions);
        var parentEl = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
        if (parentEl) {
          parentEl.insertAdjacentHTML('afterend', childHtml);
        }
      }
      var element = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
      this.animateTweetInsertion(element);
    }
  }, {
    key: "insertThreadReply",
    value: function insertThreadReply(tweet) {
      if (!tweet || tweet.parent_id !== this.active_signature) {
        return;
      }
      var container = "".concat(this.container, " .list[data-panel=\"thread\"]");
      var panel = document.querySelector(container);
      if (!panel) {
        return;
      }
      var options = {
        chainPrev: true,
        presentation: 'reply',
        reply: true
      };
      var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
      var focusedEl = panel.querySelector("article.tweet[data-id=\"".concat(this.active_signature, "\"]"));
      var replies = panel.querySelectorAll("article.tweet:not([data-id=\"".concat(this.active_signature, "\"])"));
      var lastReply = replies.length ? replies[replies.length - 1] : null;
      var anchor = lastReply || focusedEl;
      if (lastReply) {
        lastReply.classList.add('chain-next', 'chain-continue');
      } else if (focusedEl) {
        focusedEl.classList.add('chain-next', 'chain-continue');
      }
      if (anchor) {
        anchor.insertAdjacentHTML('afterend', html);
      } else {
        this.app.browser.addElementToSelector(html, container);
      }
      if (!this.pagination.thread.chain.includes(tweet.signature)) {
        this.pagination.thread.chain.push(tweet.signature);
      }
      this.pagination.thread.cursor += 1;
      var element = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
      this.animateTweetInsertion(element);
    }
  }, {
    key: "animateTweetInsertion",
    value: function animateTweetInsertion(element) {
      if (!element) {
        return;
      }
      element.classList.add('enter');
      var _onEnd = function onEnd() {
        element.classList.remove('enter');
        element.removeEventListener('animationend', _onEnd);
      };
      element.addEventListener('animationend', _onEnd);
    }
  }, {
    key: "renderTweetWithCriticalChild",
    value: function renderTweetWithCriticalChild(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.renderTweetChain(tweet, container, options, false);
    }
  }, {
    key: "renderCriticalChildChain",
    value: function renderCriticalChildChain(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.renderTweetChain(tweet, container, options, true);
    }
  }, {
    key: "renderTweetChain",
    value: function renderTweetChain(tweet, container) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var followFullChain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!tweet) {
        return;
      }
      var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
      var renderOptions = _objectSpread({}, options);
      if (child) {
        renderOptions.chainNext = true;
        renderOptions.chainContinue = true;
        // Parent of a critical-child stub reads as conversation root.
        if (!renderOptions.presentation && !renderOptions.focused) {
          renderOptions.presentation = 'root';
          renderOptions.root = true;
        }
      }
      tweet.render(container, renderOptions);
      if (!child) {
        return;
      }
      var childOptions = {
        chainPrev: true,
        presentation: 'reply',
        reply: true
      };
      if (followFullChain) {
        this.renderTweetChain(child, container, childOptions, true);
        return;
      }
      child.render(container, childOptions);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      this.attachTweetNavigation(root);
      this.attachTweetImageViewer(root);
      this.attachThreadContext(root);
      this.attachTweetMenu(root);
      this.attachTweetReply(root);
      this.attachTweetLike(root);
      this.attachTweetRetweet(root);
      this.attachTweetShare(root);
      this.attachFeedHeaderBack(root);
      this.attachPermalinkRetry(root);
      this.attachScrollEvents();
      this.attachViewportChrome();
      this.attachBrowserHistory();
    }
  }, {
    key: "attachViewportChrome",
    value: function attachViewportChrome() {
      var _this0 = this;
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return;
      }
      if (this._viewportChromeBound) {
        return;
      }
      this._viewportChromeBound = true;
      this._compactViewportQuery = window.matchMedia('(max-width: 600px)');
      var onChange = function onChange() {
        _this0.syncFeedHeader();
      };
      if (typeof this._compactViewportQuery.addEventListener === 'function') {
        this._compactViewportQuery.addEventListener('change', onChange);
      } else if (typeof this._compactViewportQuery.addListener === 'function') {
        this._compactViewportQuery.addListener(onChange);
      }
    }
  }, {
    key: "attachFeedHeaderBack",
    value: function attachFeedHeaderBack(root) {
      var _this1 = this;
      if (!root || root.dataset.feedHeaderBackBound === '1') {
        return;
      }
      root.dataset.feedHeaderBackBound = '1';
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.back');
        if (!btn || !root.contains(btn) || btn.hidden) {
          return;
        }
        e.preventDefault();
        _this1.navigateBackToTimeline();
      });
    }
  }, {
    key: "attachPermalinkRetry",
    value: function attachPermalinkRetry(root) {
      var _this10 = this;
      if (!root || root.dataset.permalinkRetryBound === '1') {
        return;
      }
      root.dataset.permalinkRetryBound = '1';
      root.addEventListener('click', function (e) {
        var retry = e.target.closest('.feed-status .retry');
        if (!retry || !_this10.pending_route_signature) {
          return;
        }
        e.preventDefault();
        _this10.applyLocationRoute({
          refresh: true
        });
      });
    }
  }, {
    key: "attachThreadContext",
    value: function attachThreadContext(root) {
      var _this11 = this;
      if (!root || root.dataset.threadContextBound === '1') {
        return;
      }
      root.dataset.threadContextBound = '1';
      root.addEventListener('click', function (e) {
        var link = e.target.closest('.thread-context');
        if (!link) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var rootSignature = link.getAttribute('data-root') || '';
        if (rootSignature) {
          _this11.openEntireThread(rootSignature);
        }
      });
    }
  }, {
    key: "openEntireThread",
    value: function () {
      var _openEntireThread = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(rootSignature) {
        var result, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(!rootSignature || !this.mod.getTweet(rootSignature))) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, null);
            case 1:
              // Show every relationship already in memory immediately, then refresh the
              // root thread so replies known only to an archive peer are included too.
              this.renderThread(rootSignature);
              _context6.p = 2;
              _context6.n = 3;
              return this.mod.loadTweetThread(rootSignature);
            case 3:
              result = _context6.v;
              if ((result === null || result === void 0 ? void 0 : result.status) === 'loaded' && this.mode === 'thread' && this.active_signature === rootSignature) {
                this.renderThread(rootSignature, {
                  updateHistory: false
                });
              }
              return _context6.a(2, result);
            case 4:
              _context6.p = 4;
              _t4 = _context6.v;
              console.error('RedSquare complete thread lookup failed:', _t4);
              return _context6.a(2, {
                status: 'error',
                reason: 'lookup-failed',
                tweet: null
              });
          }
        }, _callee6, this, [[2, 4]]);
      }));
      function openEntireThread(_x3) {
        return _openEntireThread.apply(this, arguments);
      }
      return openEntireThread;
    }()
  }, {
    key: "attachTweetReply",
    value: function attachTweetReply(root) {
      var _this12 = this;
      if (!root || root.dataset.tweetReplyBound === '1') {
        return;
      }
      root.dataset.tweetReplyBound = '1';
      root.addEventListener('click', function (e) {
        var replyButton = e.target.closest('.tool.comment');
        if (!replyButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = replyButton.closest('article.tweet');
        var signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
        var tweet = _this12.mod.getTweet(signature);
        if (tweet) {
          var _this12$mod$compose_o;
          (_this12$mod$compose_o = _this12.mod.compose_overlay) === null || _this12$mod$compose_o === void 0 || _this12$mod$compose_o.open({
            reply_to: tweet,
            mode: 'reply'
          });
        }
      });
    }
  }, {
    key: "attachTweetLike",
    value: function attachTweetLike(root) {
      var _this13 = this;
      if (!root || root.dataset.tweetLikeBound === '1') {
        return;
      }
      root.dataset.tweetLikeBound = '1';
      root.addEventListener('click', /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
          var _tweet$tx;
          var likeButton, tweetArticle, signature, tweet, keys, _iterator1, _step1, slip, publicKey, unsigned, _t5;
          return _regenerator().w(function (_context7) {
            while (1) switch (_context7.p = _context7.n) {
              case 0:
                likeButton = e.target.closest('.tool.like');
                if (likeButton) {
                  _context7.n = 1;
                  break;
                }
                return _context7.a(2);
              case 1:
                e.preventDefault();
                e.stopPropagation();
                tweetArticle = likeButton.closest('article.tweet');
                signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
                tweet = _this13.mod.getTweet(signature);
                if (tweet !== null && tweet !== void 0 && tweet.signature) {
                  _context7.n = 2;
                  break;
                }
                return _context7.a(2);
              case 2:
                keys = [];
                if (tweet.publicKey) {
                  keys.push(tweet.publicKey);
                }
                if ((_tweet$tx = tweet.tx) !== null && _tweet$tx !== void 0 && _tweet$tx.to) {
                  _iterator1 = _createForOfIteratorHelper(tweet.tx.to);
                  try {
                    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                      slip = _step1.value;
                      publicKey = slip === null || slip === void 0 ? void 0 : slip.publicKey;
                      if (publicKey && !keys.includes(publicKey)) {
                        keys.push(publicKey);
                      }
                    }
                  } catch (err) {
                    _iterator1.e(err);
                  } finally {
                    _iterator1.f();
                  }
                }
                _context7.p = 3;
                _context7.n = 4;
                return _this13.mod.createLikeTweetTransaction({
                  signature: tweet.signature
                }, keys);
              case 4:
                unsigned = _context7.v;
                _context7.n = 5;
                return unsigned.sign();
              case 5:
                _context7.n = 6;
                return _this13.app.network.propagateTransaction(unsigned);
              case 6:
                _context7.n = 7;
                return _this13.mod.receiveLikeTweetTransaction(unsigned);
              case 7:
                _context7.n = 9;
                break;
              case 8:
                _context7.p = 8;
                _t5 = _context7.v;
                console.error('RedSquare like failed:', _t5);
                siteMessage('Unable to like tweet', 2500);
              case 9:
                return _context7.a(2);
            }
          }, _callee7, null, [[3, 8]]);
        }));
        return function (_x4) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "attachTweetRetweet",
    value: function attachTweetRetweet(root) {
      var _this14 = this;
      if (!root || root.dataset.tweetRetweetBound === '1') {
        return;
      }
      root.dataset.tweetRetweetBound = '1';
      root.addEventListener('click', function (e) {
        var retweetButton = e.target.closest('.tool.retweet');
        if (!retweetButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = retweetButton.closest('article.tweet');
        var signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
        var tweet = _this14.mod.getTweet(signature);
        if (tweet) {
          var _this14$mod$compose_o;
          (_this14$mod$compose_o = _this14.mod.compose_overlay) === null || _this14$mod$compose_o === void 0 || _this14$mod$compose_o.open({
            mode: 'retweet',
            retweet_of: tweet
          });
        }
      });
    }
  }, {
    key: "attachTweetShare",
    value: function attachTweetShare(root) {
      var _this15 = this;
      if (!root || root.dataset.tweetShareBound === '1') {
        return;
      }
      root.dataset.tweetShareBound = '1';
      root.addEventListener('click', /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
          var shareButton, tweetArticle, signature, longUrl, url, _t6;
          return _regenerator().w(function (_context8) {
            while (1) switch (_context8.p = _context8.n) {
              case 0:
                shareButton = e.target.closest('.tool.share');
                if (shareButton) {
                  _context8.n = 1;
                  break;
                }
                return _context8.a(2);
              case 1:
                e.preventDefault();
                e.stopPropagation();
                tweetArticle = shareButton.closest('article.tweet');
                signature = (tweetArticle === null || tweetArticle === void 0 ? void 0 : tweetArticle.getAttribute('data-id')) || '';
                if (signature) {
                  _context8.n = 2;
                  break;
                }
                return _context8.a(2);
              case 2:
                longUrl = _this15.mod.returnTweetUrl(signature);
                _context8.p = 3;
                _context8.n = 4;
                return _this15.mod.createShortLink(longUrl);
              case 4:
                url = _context8.v;
                _this15.app.browser.handleShare({
                  title: 'Saito RedSquare Post',
                  url: url
                });
                _context8.n = 6;
                break;
              case 5:
                _context8.p = 5;
                _t6 = _context8.v;
                console.error('RedSquare share failed:', _t6);
                _this15.app.browser.handleShare({
                  title: 'Saito RedSquare Post',
                  url: longUrl
                });
              case 6:
                return _context8.a(2);
            }
          }, _callee8, null, [[3, 5]]);
        }));
        return function (_x5) {
          return _ref9.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "attachTweetMenu",
    value: function attachTweetMenu(root) {
      var _this16 = this;
      if (!root || root.dataset.tweetMenuBound === '1') {
        return;
      }
      root.dataset.tweetMenuBound = '1';
      root.addEventListener('click', function (e) {
        var _this16$mod$tweet_men;
        var moreButton = e.target.closest('.tool.more');
        if (!moreButton) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var tweetArticle = moreButton.closest('article.tweet');
        if (!tweetArticle) {
          return;
        }
        var signature = tweetArticle.getAttribute('data-id') || '';
        if (!signature) {
          return;
        }
        var tweet = _this16.mod.getTweet(signature);
        if (!tweet) {
          return;
        }
        (_this16$mod$tweet_men = _this16.mod.tweet_menu) === null || _this16$mod$tweet_men === void 0 || _this16$mod$tweet_men.toggle({
          anchor: moreButton,
          tweet: tweet
        });
      });
    }
  }, {
    key: "attachTweetNavigation",
    value: function attachTweetNavigation(root) {
      var _this17 = this;
      if (!root || root.dataset.tweetNavigationBound === '1') {
        return;
      }
      root.dataset.tweetNavigationBound = '1';
      root.addEventListener('click', function (e) {
        var signature = Manager.resolveClickedSignature(e.target);
        if (!signature) {
          return;
        }
        var tweet = _this17.mod.getTweet(signature);
        if (tweet !== null && tweet !== void 0 && tweet.ephemeral) {
          var href = String(tweet.href || '').trim();
          if (!href) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          if (typeof navigateWindow === 'function') {
            navigateWindow(href);
          } else if (typeof window !== 'undefined') {
            window.location.assign(href);
          }
          return;
        }
        _this17.renderThread(signature);
      });
    }
  }, {
    key: "attachTweetImageViewer",
    value: function attachTweetImageViewer(root) {
      var _this18 = this;
      if (!root || root.dataset.tweetImageViewerBound === '1') {
        return;
      }
      root.dataset.tweetImageViewerBound = '1';
      var openImage = function openImage(image) {
        var gallery = image.closest('.gallery');
        var galleryImages = gallery ? Array.from(gallery.querySelectorAll('.grid img')) : [];
        var imageIndex = galleryImages.indexOf(image);
        var images = galleryImages.map(function (galleryImage) {
          return galleryImage.getAttribute('src') || '';
        }).filter(Boolean);
        if (imageIndex < 0 || images.length === 0) {
          return;
        }
        _this18.image_overlay = new SaitoImageOverlay(_this18.app, _this18.mod, images);
        _this18.image_overlay.render(imageIndex);
      };
      root.addEventListener('click', function (e) {
        var image = e.target.closest('.gallery img');
        if (!image || !root.contains(image)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openImage(image);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') {
          return;
        }
        var image = e.target.closest('.gallery img');
        if (!image || !root.contains(image)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        openImage(image);
      });
    }
  }, {
    key: "attachScrollEvents",
    value: function attachScrollEvents() {
      var _this19 = this;
      if (this.scroll_bound) {
        return;
      }
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return;
      }
      this.scroll_bound = true;
      scroller.addEventListener('scroll', function () {
        if (_this19.scroll_raf) {
          return;
        }
        _this19.scroll_raf = requestAnimationFrame(function () {
          _this19.scroll_raf = null;
          _this19.onScroll();
        });
      }, {
        passive: true
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      if (!this.isNearBottom()) {
        return;
      }
      this.loadMoreIfNeeded();
    }
  }, {
    key: "isNearBottom",
    value: function isNearBottom() {
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return false;
      }
      var remaining = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
      return remaining <= SCROLL_THRESHOLD_PX;
    }
  }, {
    key: "isNearTop",
    value: function isNearTop() {
      var scroller = this.getScrollContainer();
      if (!scroller) {
        return true;
      }
      return scroller.scrollTop <= SCROLL_THRESHOLD_PX;
    }
  }, {
    key: "fetchRemoteTransactions",
    value: function fetchRemoteTransactions(type, direction) {
      var _this20 = this;
      var _ref0 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref0$announce = _ref0.announce,
        announce = _ref0$announce === void 0 ? false : _ref0$announce;
      this.mod.loadTransactions(type, direction, function (result) {
        var payload = result || {
          type: type,
          direction: direction,
          added: [],
          updated: [],
          ignored: [],
          exhausted: true
        };
        if (direction === 'newer') {
          _this20.onNewerContentLoaded(payload, {
            announce: announce
          });
        }
      });
    }
  }, {
    key: "onPeersUpdated",
    value: function onPeersUpdated() {
      if (this.pending_route_signature || this.mod.returnTweetSignatureFromLocation()) {
        this.applyLocationRoute({
          refresh: true
        });
      }
      if (this.isProfileMode()) {
        var source = this.getActiveProfileSource();
        source.exhausted = false;
        this.getPaginationState().exhausted = false;
        this.loadMoreIfNeeded();
      }
      if (this.mode === 'timeline' && this.timeline_rendered) {
        this.fetchRemoteTransactions('tweets', 'newer');
      }
    }
  }, {
    key: "onNewerContentLoaded",
    value: function onNewerContentLoaded(result) {
      var _ref1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref1$announce = _ref1.announce,
        announce = _ref1$announce === void 0 ? false : _ref1$announce;
      if (!result) {
        return;
      }
      if (result.type === 'tweets') {
        this.handleNewerTweets(result, {
          announce: announce
        });
        return;
      }
      if (result.type === 'notifications' && this.mode === 'notifications') {
        this.handleNewerNotifications(result);
      }
    }
  }, {
    key: "handleNewerTweets",
    value: function handleNewerTweets(result) {
      var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref10$announce = _ref10.announce,
        announce = _ref10$announce === void 0 ? false : _ref10$announce;
      // Archive hydration is initial feed state; only post-load event paths may
      // place genuinely new tweets behind the notification banner.
      var signatures = Array.from(new Set(announce ? Array.isArray(result === null || result === void 0 ? void 0 : result.new_tweets) ? result.new_tweets : [] : Array.isArray(result === null || result === void 0 ? void 0 : result.added) ? result.added : []));
      if (!(signatures !== null && signatures !== void 0 && signatures.length)) {
        return;
      }
      var timeline = document.querySelector("".concat(this.container, " .list[data-panel=\"timeline\"]"));
      var rendered = new Set();
      var immediatelyVisible = [];
      var newestRenderedAt = 0;
      var _iterator10 = _createForOfIteratorHelper((timeline === null || timeline === void 0 ? void 0 : timeline.querySelectorAll('article.tweet[data-id]')) || []),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var element = _step10.value;
          var _signature3 = element.getAttribute('data-id') || '';
          var _tweet3 = this.mod.getTweet(_signature3);
          if (_signature3) {
            rendered.add(_signature3);
          }
          newestRenderedAt = Math.max(newestRenderedAt, Number(_tweet3 === null || _tweet3 === void 0 ? void 0 : _tweet3.created_at) || 0);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      for (var _i3 = 0, _signatures = signatures; _i3 < _signatures.length; _i3++) {
        var signature = _signatures[_i3];
        var tweet = this.mod.getTweet(signature);
        if (!tweet || tweet.parent_id || rendered.has(signature) || newestRenderedAt > 0 && Number(tweet.created_at) < newestRenderedAt) {
          continue;
        }
        if (announce && this.timeline_rendered) {
          if (!this.pending_newer_tweets.includes(signature)) {
            this.pending_newer_tweets.push(signature);
          }
        } else {
          immediatelyVisible.push(signature);
        }
      }
      if (immediatelyVisible.length) {
        this.prependTimelineTweets(immediatelyVisible);
        this.pagination.timeline.exhausted = false;
        this.syncFeedStatus();
      }
      if (this.pending_newer_tweets.length && this.mode === 'timeline') {
        this.showNewPostsBanner();
      }

      // Initial archive pages can contain mostly replies. Continue filling the
      // viewport when the newly hydrated roots do not create a scrollbar.
      if (!announce && this.mode === 'timeline' && this.isNearBottom()) {
        this.loadMoreIfNeeded();
      }
    }
  }, {
    key: "syncPendingNewerTweets",
    value: function syncPendingNewerTweets() {
      if (!this.pending_newer_tweets.length) {
        this.hideNewPostsBanner();
        return;
      }
      if (this.mode === 'timeline') {
        this.showNewPostsBanner();
      }
    }
  }, {
    key: "handleNewerNotifications",
    value: function handleNewerNotifications(result) {
      var _result$added;
      if (!(result !== null && result !== void 0 && (_result$added = result.added) !== null && _result$added !== void 0 && _result$added.length)) {
        return;
      }
      this.prependNotifications(result.added);
      this.pagination.notifications.exhausted = false;
      this.syncFeedStatus();
    }
  }, {
    key: "prependTimelineTweets",
    value: function prependTimelineTweets(signatures) {
      var _this21 = this;
      var container = "".concat(this.container, " .list[data-panel=\"timeline\"]");
      var panel = document.querySelector(container);
      if (!panel || !(signatures !== null && signatures !== void 0 && signatures.length)) {
        return;
      }
      var tweets = signatures.map(function (signature) {
        return _this21.mod.getTweet(signature);
      }).filter(function (tweet) {
        return tweet && !tweet.parent_id;
      }).sort(function (a, b) {
        return (a.created_at || 0) - (b.created_at || 0);
      });
      var _iterator11 = _createForOfIteratorHelper(tweets),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var tweet = _step11.value;
          var child = tweet.critical_child ? this.mod.getTweet(tweet.critical_child) : null;
          var options = {};
          if (child) {
            options.chainNext = true;
            options.chainContinue = true;
            options.presentation = 'root';
            options.root = true;
          }
          var html = TweetTemplate(tweet, tweet.buildClassName(options), options);
          this.app.browser.prependElementToSelector(html, container);
          if (child) {
            var childOptions = {
              chainPrev: true,
              presentation: 'reply',
              reply: true
            };
            var childHtml = TweetTemplate(child, child.buildClassName(childOptions), childOptions);
            var parentEl = panel.querySelector("article.tweet[data-id=\"".concat(tweet.signature, "\"]"));
            if (parentEl) {
              parentEl.insertAdjacentHTML('afterend', childHtml);
            }
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      this.pagination.timeline.cursor += signatures.length;
      this.timeline_rendered = true;
    }
  }, {
    key: "prependNotifications",
    value: function prependNotifications(signatures) {
      var _this22 = this,
        _this$mod$moderate,
        _this$mod$moderate$en;
      var container = "".concat(this.container, " .list[data-panel=\"notifications\"]");
      var panel = document.querySelector(container);
      if (!panel || !(signatures !== null && signatures !== void 0 && signatures.length)) {
        return;
      }
      var notifications = signatures.map(function (signature) {
        return _this22.mod.getNotification(signature);
      }).filter(Boolean).sort(function (a, b) {
        return (a.created_at || 0) - (b.created_at || 0);
      });
      var _iterator12 = _createForOfIteratorHelper(notifications),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var notification = _step12.value;
          var html = notification.renderHTML();
          if (html) {
            this.app.browser.prependElementToSelector(html, container);
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      this.pagination.notifications.cursor += signatures.length;
      this.notifications_rendered = true;
      (_this$mod$moderate = this.mod.moderate) === null || _this$mod$moderate === void 0 || (_this$mod$moderate$en = _this$mod$moderate.ensureTop) === null || _this$mod$moderate$en === void 0 || _this$mod$moderate$en.call(_this$mod$moderate);
    }
  }, {
    key: "showNewPostsBanner",
    value: function showNewPostsBanner() {
      var _this23 = this;
      if (!this.pending_newer_tweets.length || this.mode !== 'timeline') {
        return;
      }
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var banner = root.querySelector('.new-posts-banner');
      if (!banner) {
        var body = root.querySelector('.body');
        var host = (body === null || body === void 0 ? void 0 : body.parentElement) || root;
        banner = document.createElement('button');
        banner.className = 'new-posts-banner';
        banner.type = 'button';
        banner.textContent = 'New posts available';
        banner.addEventListener('click', function () {
          _this23.revealPendingNewerTweets();
        });
        if (body && host) {
          host.insertBefore(banner, body);
        } else {
          host.prepend(banner);
        }
      }
      banner.hidden = false;
    }
  }, {
    key: "hideNewPostsBanner",
    value: function hideNewPostsBanner() {
      var banner = document.querySelector("".concat(this.container, " .new-posts-banner"));
      if (!banner) {
        return;
      }
      banner.hidden = true;
    }
  }, {
    key: "revealPendingNewerTweets",
    value: function revealPendingNewerTweets() {
      this.flushPendingNewerTweets({
        scrollToTop: true
      });
    }
  }, {
    key: "flushPendingNewerTweets",
    value: function flushPendingNewerTweets() {
      var _this24 = this;
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref11$scrollToTop = _ref11.scrollToTop,
        scrollToTop = _ref11$scrollToTop === void 0 ? false : _ref11$scrollToTop;
      var signatures = this.pending_newer_tweets.slice();
      this.pending_newer_tweets = [];
      this.hideNewPostsBanner();
      if (!signatures.length) {
        return;
      }
      this.prependTimelineTweets(signatures);
      this.pagination.timeline.exhausted = false;
      this.syncFeedStatus();
      if (scrollToTop) {
        requestAnimationFrame(function () {
          var scroller = _this24.getScrollContainer();
          if (scroller) {
            scroller.scrollTop = 0;
          }
        });
      }
    }
  }, {
    key: "sliceUnrendered",
    value: function sliceUnrendered(signatures, cursor, batchSize) {
      if (cursor >= signatures.length) {
        return [];
      }
      return signatures.slice(cursor, cursor + batchSize);
    }
  }, {
    key: "loadMoreIfNeeded",
    value: function loadMoreIfNeeded() {
      var state = this.getPaginationState();
      if (state.loading || state.exhausted || this._notifications_bootstrapping || this._timeline_bootstrapping) {
        return;
      }
      this.loadMore();
    }
  }, {
    key: "loadMore",
    value: function () {
      var _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _this25 = this;
        var state, continueLoading, rendered, source, available, result, type, timeline, pending;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              state = this.getPaginationState();
              if (!(state.loading || state.exhausted || this._notifications_bootstrapping || this._timeline_bootstrapping)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              state.loading = true;
              this.syncFeedStatus();
              continueLoading = false;
              _context9.p = 2;
              if (!this.isProfileMode()) {
                _context9.n = 5;
                break;
              }
              rendered = this.appendProfileBatch();
              if (rendered) {
                _context9.n = 4;
                break;
              }
              _context9.n = 3;
              return this.loadProfileArchivePage();
            case 3:
              this.appendProfileBatch();
            case 4:
              source = this.getActiveProfileSource();
              available = this.collectProfileTweets().length;
              state.exhausted = Boolean(source.exhausted && state.cursor >= available);
              continueLoading = !state.exhausted && this.isNearBottom();
              if (continueLoading) {
                setTimeout(function () {
                  return _this25.loadMoreIfNeeded();
                }, 0);
              }
              return _context9.a(2);
            case 5:
              if (!(this.mode === 'thread')) {
                _context9.n = 7;
                break;
              }
              _context9.n = 6;
              return ManagerLoadMore.loadMore({
                mode: this.mode,
                mod: this.mod,
                pagination: this.pagination,
                active_thread_id: this.active_thread_id,
                active_signature: this.active_signature
              });
            case 6:
              result = _context9.v;
              continueLoading = this.applyOlderLoadResult(result);
              return _context9.a(2);
            case 7:
              type = this.mode === 'notifications' ? 'notifications' : 'tweets';
              timeline = type === 'notifications' ? this.mod.notifications_timeline : this.mod.tweets_timeline;
              pending = this.sliceUnrendered(timeline, state.cursor, state.batchSize);
              if (!(pending.length > 0)) {
                _context9.n = 8;
                break;
              }
              continueLoading = this.applyOlderLoadResult({
                type: type,
                direction: 'older',
                added: pending.slice(),
                updated: [],
                ignored: [],
                exhausted: false
              });
              return _context9.a(2);
            case 8:
              _context9.n = 9;
              return new Promise(function (resolve) {
                var settled = false;
                var finish = function finish(result) {
                  if (settled) {
                    return;
                  }
                  settled = true;
                  continueLoading = _this25.applyOlderLoadResult(result || {
                    type: type,
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  });
                  resolve();
                };
                var timer = setTimeout(function () {
                  finish({
                    type: type,
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  });
                }, 12000);
                try {
                  _this25.mod.loadTransactions(type, 'older', function (result) {
                    clearTimeout(timer);
                    finish(result);
                  });
                } catch (err) {
                  clearTimeout(timer);
                  finish({
                    type: type,
                    direction: 'older',
                    added: [],
                    updated: [],
                    ignored: [],
                    exhausted: true
                  });
                }
              });
            case 9:
              _context9.p = 9;
              state.loading = false;
              this.syncFeedStatus();
              return _context9.f(9);
            case 10:
              if (continueLoading) {
                this.loadMoreIfNeeded();
              }
            case 11:
              return _context9.a(2);
          }
        }, _callee9, this, [[2,, 9, 10]]);
      }));
      function loadMore() {
        return _loadMore.apply(this, arguments);
      }
      return loadMore;
    }()
  }, {
    key: "applyOlderLoadResult",
    value: function applyOlderLoadResult(result) {
      var _result$added2;
      var state = this.getPaginationState();
      if ((_result$added2 = result.added) !== null && _result$added2 !== void 0 && _result$added2.length) {
        this.appendLoadedItems(result);
        this.syncFeedStatus();
        return this.isNearBottom();
      }

      // A non-empty archive page may contain only transactions already cached
      // locally. Its cursor still advanced, so keep paging until the archive says
      // it is actually exhausted or a visible tweet is found.
      state.exhausted = Boolean(result.exhausted);
      this.syncFeedStatus();
      return !state.exhausted && this.isNearBottom();
    }
  }, {
    key: "ensureScrollFooter",
    value: function ensureScrollFooter() {
      return this.ensureFeedStatus();
    }
  }, {
    key: "ensureFeedStatus",
    value: function ensureFeedStatus() {
      var panel = this.getActivePanelElement();
      if (!panel) {
        return null;
      }
      var footer = panel.querySelector('.feed-status');

      // Upgrade leftover terminators from earlier builds.
      if (!footer) {
        panel.querySelectorAll('.feed-end, .scroll-footer').forEach(function (node) {
          return node.remove();
        });
        this.app.browser.addElementToElement(ManagerScrollFooterTemplate(), panel);
        footer = panel.querySelector('.feed-status');
      }
      if (footer && footer.parentNode === panel) {
        panel.appendChild(footer);
      }
      return footer;
    }
  }, {
    key: "getRenderedItemCount",
    value: function getRenderedItemCount() {
      var panel = this.getActivePanelElement();
      if (!panel) {
        return 0;
      }
      return _toConsumableArray(panel.querySelectorAll('article.tweet, article.notification')).filter(function (el) {
        return !el.closest('.moderate');
      }).length;
    }
  }, {
    key: "hasCompletedInitialLoad",
    value: function hasCompletedInitialLoad() {
      if (this.isProfileMode()) {
        return true;
      }
      if (this.mode === 'timeline') {
        return this.timeline_rendered && !this._timeline_bootstrapping;
      }
      if (this.mode === 'notifications') {
        return this.notifications_rendered && !this._notifications_bootstrapping;
      }
      if (this.mode === 'thread') {
        return true;
      }
      return true;
    }

    /**
     * Mutually exclusive feed UI status:
     * loading | content | empty | end
     */
  }, {
    key: "resolveFeedStatus",
    value: function resolveFeedStatus() {
      var state = this.getPaginationState();
      if (this.mode === 'thread' && this.permalink_state) {
        return this.permalink_state.status;
      }
      if (state.loading || this._timeline_bootstrapping || this._notifications_bootstrapping) {
        return 'loading';
      }
      var count = this.getRenderedItemCount();
      if (count === 0) {
        if (!this.hasCompletedInitialLoad()) {
          return 'loading';
        }
        return 'empty';
      }
      if (state.exhausted) {
        return 'end';
      }
      return 'content';
    }
  }, {
    key: "syncFeedStatus",
    value: function syncFeedStatus() {
      var footer = this.ensureFeedStatus();
      if (!footer) {
        return;
      }
      var status = this.resolveFeedStatus();
      footer.dataset.status = status;
      var message = footer.querySelector('.message');
      var retry = footer.querySelector('.retry');
      if (message) {
        // Loading is spinner-only — never keep empty/end copy under the loader.
        message.textContent = status === 'loading' || status === 'content' ? '' : this.getFeedStatusMessage(status);
      }
      if (retry) {
        retry.hidden = status !== 'unavailable' && status !== 'error';
      }
    }
  }, {
    key: "showScrollFooter",
    value: function showScrollFooter() {
      this.syncFeedStatus();
    }
  }, {
    key: "hideScrollFooter",
    value: function hideScrollFooter() {
      this.syncFeedStatus();
    }
  }, {
    key: "syncScrollFooter",
    value: function syncScrollFooter() {
      this.syncFeedStatus();
    }
  }], [{
    key: "isTweetActionTarget",
    value: function isTweetActionTarget(element) {
      if (!element || typeof element.closest !== 'function') {
        return false;
      }
      return Boolean(element.closest('.controls, .show-more, .tool, .gallery'));
    }
  }, {
    key: "resolveClickedSignature",
    value: function resolveClickedSignature(element) {
      if (!element || typeof element.closest !== 'function') {
        return '';
      }
      if (Manager.isTweetActionTarget(element)) {
        return '';
      }
      var tweet = element.closest('article.tweet');
      if (tweet) {
        return tweet.getAttribute('data-id') || '';
      }
      var notification = element.closest('article.notification');
      if (notification) {
        return notification.getAttribute('data-tweet-id') || '';
      }
      return '';
    }
  }]);
}();
module.exports = Manager;